import img1 from "../../assets/Rectangle29.png"
import img2 from "../../assets/Rectangle15.png"
import img3 from "../../assets/Rectangle16.png"
import img4 from "../../assets/Rectangle17.png"
import img5 from "../../assets/Rectangle19.png"
import img6 from "../../assets/Rectangle20.png"
import img7 from "../../assets/Rectangle18.png"


export const Newrel = [
    {
      title: "Life in a bubble",
      artist: "Sean swadder",
      time:
        "2:34:45",
      img: <img className="tyu" src={img1} alt="img" />,
    },
    {
        title: "Mountain",
        artist: "Dj yk mule",
        time:
          "1:02:42",
        img:  <img src={img2} alt="img" />,
      },
      {
        title: "Limits",
        artist: "obi dotti",
        time:
          "2:01:25",
        img:  <img src={img3} alt="img" />,
      },
      {
        title: "Everything's black",
        artist: "Dj sick",
        time:
          "2:34:45",
        img:  <img src={img4} alt="img" />,
      },
      {
        title: "Cancelled",
        artist: "obi dotti",
        time:
          "2:01:25",
        img:  <img src={img5} alt="img" />,
      },
      {
        title: "Nomad",
        artist: "obi dotti",
        time:
          "2:01:25",
        img:  <img src={img6} alt="img" />,
      },
      {
        title: "Blind",
        artist: "obi dotti",
        time:
          "2:01:25",
        img:  <img src={img7} alt="img" />,
      },

 
  ];
  